<template>
    <div id="parts">
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            Smart KCI
            <div
                style="float: right"
                v-if="
                    team_name == 'SUPPORTUC' ||
                        team_name == 'PSG' ||
                        team_name == 'IPG'
                "
            >
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="mb-1"
                            x-small
                            @click="get_sms_type()"
                            color="amber"
                            fab
                            v-on="on"
                            target="_blank"
                        >
                            <v-icon color="primary">mdi-email-outline</v-icon>
                        </v-btn>
                    </template>
                    <span> Send SMS</span>
                </v-tooltip>
            </div>
        </v-alert>
        <v-row>
            <v-col cols="12" class="mar-t-15">
                <v-simple-table class="table-inv mb-3">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center">#</th>
                                <th class="text-center">Type</th>
                                <th class="text-center">Tel</th>
                                <th class="text-center">Created</th>
                            </tr>
                        </thead>
                        <tbody v-if="data_main.length == 0">
                            <tr>
                                <td class="text-center" colspan="4">
                                    no results found
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(row, index) in data_main" :key="index">
                                <td class="text-center">{{ index + 1 }}.</td>
                                <td>
                                    <span class="ml-2">
                                        {{ row.type }}
                                    </span>
                                </td>
                                <td class="text-center">{{ row.tel }}</td>
                                <td class="text-center">
                                    {{ row.created_name }} <br />
                                    <v-chip small>
                                        {{ row.created_date }}
                                    </v-chip>
                                </td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>

        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog_detail" persistent width="450">
                    <v-card>
                        <v-form method="post" id="nativeForm" v-model="valid">
                            <v-card-title>
                                <span class="text-h5">Smart KCI</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" >
                                            <v-text-field
                                                v-model="sms.tel"
                                                label="เบอร์โทร 66xxxxxxxxx"
                                                outlined
                                                dense
                                                :rules="rules1"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-select
                                                :items="data_sms_type"
                                                item-text="type_name"
                                                item-value="type_id"
                                                label="Type Sms"
                                                menu-props="auto"
                                                v-model="sms.type"
                                                outlined
                                                dense
                                                hide-details
                                                :rules="rules2"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            class="mt-2"
                                            v-if="sms.type == 4"
                                        >
                                            <v-dialog
                                                ref="dialog"
                                                v-model="modal"
                                                :return-value.sync="sms.date"
                                                persistent
                                                width="290px"
                                            >
                                                <template
                                                    v-slot:activator="{ on }"
                                                >
                                                    <v-text-field
                                                        v-model="sms.date"
                                                        label="วันที่เริ่มใช้งาน"
                                                        prepend-icon=""
                                                        readonly
                                                        v-on="on"
                                                        outlined
                                                        dense
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="date"
                                                    scrollable
                                                >
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="modal = false"
                                                    >
                                                        Cancel
                                                    </v-btn>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="
                                                            $refs.dialog.save(
                                                                date
                                                            )
                                                        "
                                                    >
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </v-col>
                                         <v-col
                                         cols="12"
                                         class="mt-2"
                                         v-if="sms.type == 3"
                                            >
                                                    <v-row>
                                                        <v-col cols="8">
                                                            <v-select
                                                                :items="
                                                                    itemsdelayedparts
                                                                "
                                                                v-model="
                                                                    statusdelayedparts
                                                                "
                                                                item-text="name"
                                                                :rules="
                                                                    notstatus
                                                                "
                                                                required
                                                                item-value="value"
                                                                label="ระยะเวลาในการ update ลูกค้า"
                                                                outlined
                                                                dense
                                                            ></v-select>
                                                        </v-col>

                                                        <v-col cols="4">
                                                            <v-text-field
                                                                v-if="
                                                                    statusdelayedparts ==
                                                                        'daily'
                                                                "
                                                                label="จำนวนวัน"
                                                                :rules="
                                                                    notday
                                                                "
                                                                required
                                                                v-model="
                                                                    dayupdate
                                                                "
                                                                maxlength="2"
                                                                @keypress="
                                                                    chkNum()
                                                                "
                                                                placeholder="ตัวเลข"
                                                                outlined
                                                                dense
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                            </v-col>
                                    </v-row>
                                </v-container>
                                <small class="red--text">
                                    *Customer Tel.
                                    {{ detailcase.customer_tel }}
                                </small>
                                <v-tooltip top class="ml-1">
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            x-small
                                            v-on="on"
                                            fab
                                            @click="
                                                doCopyLog(
                                                    detailcase.customer_tel
                                                )
                                            "
                                        >
                                            <v-icon>mdi-content-copy</v-icon>
                                        </v-btn>
                                    </template>
                                    <span
                                        >Copy
                                        {{ detailcase.customer_tel }}</span
                                    >
                                </v-tooltip>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    text
                                    class="primary--text"
                                    variant="text"
                                    @click="close_dialog()"
                                >
                                    Close
                                </v-btn>
                                <v-spacer></v-spacer>

                                <v-btn
                                    color="success"
                                    @click="check_sms()"
                                    rounded
                                    :disabled="!valid"
                                >
                                    Send SMS
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
import { indexOf } from "lodash"
import { get } from "lodash"
let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    props: ["detailcase", "maincase_id"],
    watch: {
        maincase_id: function(val) {
            this.get_data()
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        localStorage.setItem("case_id",this.detailcase.case_id)
        localStorage.setItem("learnerid", this.detailcase.subs[this.detailcase.subs.length-1].engineer_hp_learnerid)
//         console.log(localStorage.getItem("caseid"))
// console.log('this tk',this.detailcase.case_id)
    },
    mounted() {
        if (this.maincase_id != undefined) {
            this.get_data()
        }
    },
    methods: {
        async get_data() {
            this.dialog_loading = true
            await axios
                .get(url + "partner/sms/get-sms/" + this.maincase_id, this.tk)
                .then((response) => {
                    // console.log(response, "partner/sms/get-sms/")
                    this.data_main = response.data
                    this.dialog_loading = false
                })
                .catch((error) => {
                    this.dialog_loading = false
                    console.log(error, "---error")
                })
        },
        async get_sms_type() {
            this.dialog_loading = true
            await axios
                .get(url + "partner/sms/get-sms-type", this.tk)
                .then((response) => {
                    // console.log(response.data, "get-sms-type")
                    this.data_sms_type = response.data
                    // console.log('sms type',(this.data_sms_type))
                    this.dialog_loading = false
                    this.get_dialog()
                })
                .catch((error) => {
                    this.dialog_loading = false
                    console.log(error, "---error")
                })
               
        },
        async get_dialog() {
            // console.log(this.detailcase, "-detailcase")
            this.dialog_detail = true
        },
        close_dialog() {
            this.sms = {
                tel: "66",
                type: "",
            }
            this.dialog_detail = false
        },
        async check_sms(){
            if(this.sms.type == 5){
                let body = {
                            learner_id:this.detailcase.subs[this.detailcase.subs.length-1].engineer_hp_learnerid,
                            case_id:this.detailcase.case_id
                }
                        await axios.post(url+"get-fe-survey",body, this.tk)
                            .then((response) => {
                                this.FE_Survey_URL = response.data
                                // console.log('respond in case 5',this.survey_url)
                                this.save_sms()
                            })
                            .catch((error) => {
                                console.log(error, "---error")
                            }) 
                            
            }else{
                this.save_sms()
            }
        },
        async save_sms() {
            this.dialog_loading = true
            let str
            
            if (this.detailcase.sms_status == "Y") {
                if (this.detailcase.sms_language == "th") {
                    if (this.sms.type == 1) {
                        str = `ขอบคุณที่ให้ทาง HP ได้ดูแลคุณ หมายเลขอ้างอิงงานซ่อมของคุณคือ ${this.detailcase.case_id} เราจะติดต่อคุณอีกครั้งเพื่อทำการนัดหมายเป็นลำดับถัดไป สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.sms.type == 2) {
                        str = `งานซ่อมหมายเลข ${this.detailcase.case_id} พร้อมให้บริการแล้ว คุณ ${this.detailcase.engineer_name_th} จะเป็นผู้ให้บริการคุณในวันนี้  สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.sms.type == 3 && this.statusdelayedparts == "waiting eta") {
                        str = `งานซ่อมหมายเลข ${this.detailcase.case_id} เกิดความล่าช้าเนื่องจากรออะไหล่ โดยคาดว่าใช้ระยะเวลารอประมาณ 10 วัน เราจะติดต่อคุณเป็นระยะ เพื่อให้ทราบถึงความคืบหน้า HP ต้องขออภัยเป็นอย่างสูง สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.sms.type == 3 && this.statusdelayedparts == "daily") {
                        str = `งานซ่อมหมายเลข ${this.detailcase.case_id} เกิดความล่าช้าเนื่องจากรออะไหล่ โดยคาดว่าใช้ระยะเวลารอประมาณ ${this.dayupdate} วัน เราจะติดต่อคุณเป็นระยะ เพื่อให้ทราบถึงความคืบหน้า HP ต้องขออภัยเป็นอย่างสูง สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.sms.type == 4) {
                        let dd = this.sms.date.split("-")
                        let date_sms = `${dd[2]}/${dd[1]}/${dd[0]}`
                        str = `นัดหมายใหม่สำหรับงานซ่อมหมายเลข ${this.detailcase.case_id} คือวันที่ ${date_sms} กรุณารอรับการติดต่อนัดหมายจากช่างของเราอีกครั้ง สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    }else if (this.sms.type == 5) {
                        str = `งานซ่อมหมายเลข ${this.detailcase.case_id} ได้รับการแก้ไขเรียบร้อยแล้ว แชร์ความคิดเห็นของคุณและให้กำลังใจช่างของเราได้ที่ ${this.FE_Survey_URL} (ลิงก์มีอายุ 14 วัน) ขอบคุณที่ให้ทาง HP ได้ดูแลคุณ  สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589` 
                    }else if (this.sms.type == 6) {
                        str = `งานซ่อมหมายเลข ${this.detailcase.case_id} ได้รับการยกเลิกแล้ว สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    }
                } else if (this.detailcase.sms_language == "en") {
                    if (this.sms.type == 1) {
                        str = `Thank you for choosing HP, Your case no: ${this.detailcase.case_id} We will getting you back soon, if you have any queries, please contact 020781589`
                    } else if (this.sms.type == 2) {
                        str = `Case no: ${this.detailcase.case_id} is now ready for service. HP Technician ${this.detailcase.engineer_name_en} will be assisting you today.  For more information, please call 020781589.`
                    } else if (this.sms.type == 3 && this.statusdelayedparts == "waiting eta") {
                        str = `Case no: ${this.detailcase.case_id} is delayed due to waiting for parts. It is expected that the waiting period will be approximately 10 days. We will contact you periodically to keep you informed of the progress. HP deeply apologizes for the inconvenience. For more information, please call 020781589`
                    } else if (this.sms.type == 3 && this.statusdelayedparts == "daily") {
                        str = `Case no: ${this.detailcase.case_id} is delayed due to waiting for parts. It is expected that the waiting period will be approximately ${this.dayupdate} days. We will contact you periodically to keep you informed of the progress. HP deeply apologizes for the inconvenience. For more information, please call 020781589`
                    } else if (this.sms.type == 4) {
                        let dd = this.sms.date.split("-")
                        let date_sms = `${dd[2]}/${dd[1]}/${dd[0]}`
                        str = `The new appointment for Case no: ${this.detailcase.case_id} is scheduled for ${date_sms}. Please expect a follow-up call from our technician. For inquiries, call 020781589.`
                    } else if (this.sms.type == 5) {
                        str = `Case no: ${this.detailcase.case_id} has been successfully resolved. Please share your feedback and support our technician at ${this.FE_Survey_URL} (link valid for 14 days). Thank you for allowing HP to serve you. if you have any queries, please contact 020781589`
                    } else if (this.sms.type == 6) {
                        str = `Case no: ${this.detailcase.case_id} has been cancelled. For more information, please call 020781589.`
                    }
                }

                let str_th = str
                str = str
                    .split("")
                    .map((char) => addZeros(char.charCodeAt(0).toString(16)))
                    .join("")
                function addZeros(str) {
                    return ("0000" + str).slice(-4)
                }
                
                // console.log(str_th, 'check str');

                let data_save = {
                    str: str,
                    str_th: str_th,
                    tel: this.sms.tel,
                    type: this.sms.type,
                    sms_language: this.detailcase.sms_language,
                    sms_status: this.detailcase.sms_status,
                    maincase_id: this.detailcase.maincase_id,
                    subcase_id: this.detailcase.subcase_id,
                }
                // console.log(data_save, 'check data')
                
                await axios
                    .post(url + "partner/sms-online", data_save, this.tk)
                    .then((response) => {
                        // console.log(response.data, "partner/sms-online")
                        this.data_main = response.data
                        this.dialog_loading = false
                        this.close_dialog()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
        doCopyLog: function(textId) {
            let text = textId
            let result = text.substr(1)
            this.text_copy = result

            navigator.clipboard.writeText(this.text_copy)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
    },
    data() {
        return {
            itemsdelayedparts: [
                {
                    name: "Update รายวัน",
                    value: "daily",
                },
                {
                    name: "รอ ETA",
                    value: "waiting eta",
                },
            ],
            statusdelayedparts: "",
            dayupdate: "",
            notstatus: [(v) => !!v || "Status update time is required"],
            notday: [(v) => !!v || "Number of days is required"],
            text_copy: "",
            valid: false,
            tk: null,
            data_main: [],
            data_sms_type: [],
            dialog_loading: false,
            dialog_detail: false,
            sms: {
                tel: "66",
                type: "",
                date: new Date().toISOString().substr(0, 10),
            },
            date: false,
            rules1: [
                (v) =>
                    v.length === 11 ||
                    "Telephone must be less than 11 characters",
            ],
            rules2: [(v) => !!v || "Type is required"],
            role_name: localStorage.role_name,
            team_name: localStorage.team_name,
            FE_Survey_URL:null
        }
    },
}
</script>
